import Vue from 'vue'
import VueApollo from 'vue-apollo'
import { VueMasonryPlugin } from 'vue-masonry'

import * as firebase from 'firebase/app'

import 'shared-icons'

import '@/i18n'

import '@shared/plugins/element'
import i18n from '@shared/i18n-utils/i18n.vue'
import addressPartial from '@shared/form/address.vue'
import phoneInput from '@shared/form/phone-input.vue'
import LoadingSpinner from '@shared/components/loading-spinner.vue'
import CustomAlert from '@shared/components/custom-alert.vue'

import elTextarea from '@shared/form/el-textarea.vue'

import { parseDateModel } from '@/filters/date'

import '@/error-tracking'
import router from '@/router'
import store from '@/store'
import config from '@/config'

import graphQLClient from '@/graphql/client'

import App from '@/App.vue'

firebase.initializeApp(config.firebaseConfig)

Vue.config.productionTip = false

Vue.use(VueApollo)
Vue.use(VueMasonryPlugin)

Vue.component('app-i18n', i18n)
Vue.component('app-address-form-partial', addressPartial)
Vue.component('app-phone-input', phoneInput)
Vue.component('app-loading-spinner', LoadingSpinner)
Vue.component('app-custom-alert', CustomAlert)
Vue.component('el-textarea', elTextarea)

Vue.filter('parseDateModel', parseDateModel)

const apolloProvider = new VueApollo({
  defaultClient: graphQLClient,
})

export default new Vue({
  router,
  store,
  apolloProvider,
  render: h => h(App),
}).$mount('#app')
